import {ChangeDetectionStrategy, Component, input, linkedSignal} from '@angular/core';

@Component({
    selector: 'app-validation-popover',
    styleUrls: ['./validation-popover.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div [class.hidden]="hidden()" (click)="hidden.set(true)">
            <div id="popover-error">
                <ng-content />
            </div>
        </div>
    `,
})
export class ValidationPopoverComponent {
    /** A dismissed popover shows again whenever this value changes. */
    readonly resetOn = input<unknown>();

    protected readonly hidden = linkedSignal({source: this.resetOn, computation: () => false});
}
